module.exports = __webpack_public_path__ + "static/img/Ministere-Education-nationale.db3156f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Ministere-Education-nationale.svg
// module id = 541
// module chunks = 2